
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { ShareContext } from "../../context/ShareContext";
import * as Constants from "../../constants";
import JisVoiceRecorder from "../../components/jisVoicerecorder"; // Match your actual import path
import JisButton from "../../components/controls/jisButton";


function CourtRecorder() {
  const { scheduleid } = useParams();

  const { token, frequentData, setIsExpired, setAlert } = useContext(ShareContext);
  const [caseinfo, setCase] = useState(null);
  const [recorderText, setRecorderText] = useState("");
  const [caseid, setCaseid] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
   const [parties, setParties] = useState(null);
   const [stribeurl, setStribeurl] = useState(null);
   const [isListening, setIsListening] = useState(false);
  // This function intercepts the text emitted from the voice component prop
  const handleNewTranscriptionText = (incomingText) => {
    setRecorderText((prevText) => {
      return prevText ? `${prevText.trim()} ${incomingText}` : incomingText;
    });
  };
   useEffect(() => {
    if(scheduleid!=null){
      onLoadRecord();
      setStribeurl(`${Constants.apiUrl}/hearing/transcribe/${scheduleid}`);
    }
  
  }, [ scheduleid]);

   useEffect(() => {
    if(caseid!=null){
      onLoadCase(caseid);
    }
  
  }, [ caseid]);
const onLoadCase = async (_caseid) => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/mini-case-details/${_caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code === 0) {
        setCase(data.caseinfo);
        setParties(data.parties);
      } else if (data.code === -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadRecord = async () => {
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/hearing/court-recorder/${scheduleid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      
      if (data.code === 0) {
        const initialNote = data.note ?? '';
        setRecorderText(initialNote);
       // baseTextRef.current = initialNote; // Seed baseline
        if (caseid == null) {
          setCaseid(data.caseid);
        }
      } else if (data.code === -10) {
        setIsExpired(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onStatusChange = (isActive) => {
    console.log("Voice Engine Active:", isActive);
     setIsListening(isActive);
  };
  const onSaveNote = async () => {
    console.log(scheduleid, "here is schedule id");
    if (recorderText?.trim() == "" ) {
      setAlert({
        icon: "warning",
        open: true,
        title: "Warning",
        subtitle: "Please enter recording note before saving",
      });
      return;
    }

    setLoading(true);

    try {
      var req = {
        ScheduleId: scheduleid,
        note: recorderText,
      };
      const resp = await fetch(`${Constants.apiUrl}/hearing/save-court-recorder/${scheduleid}`, {
        method: "POST",
        body: JSON.stringify(req),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data, "find it here !");
      if (data.code === 0) {

        setAlert({
          open: true,
          title: "Recording Note",
          subtitle: "Recording Note saved successfully",
        });
       
      } else {
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
     
    }
  };

  return (
    <div>
      {/* ... Your Case Info Sections remain identical ... */}
       <section class="case-info">
                    <div className="summary summary_wrapper hearing_summary">
                      <div>
                        <p className="label">Parties to the Case</p>
                        <p className="value">{caseinfo?.caseTitle}</p>
                      </div>
                      <div>
                        <p className="label">Suite Number</p>
      
                        <p className="value">{caseinfo?.caseNumber}</p>
                      </div>
                      <div>
                        <p className="label">Case of Origin</p>
                        <p className="value">
                          {
                            Constants.getItemById(
                              frequentData?.caseorigin,
                              caseinfo?.caseOriginId,
                            )?.title
                          }
                        </p>
                      </div>
                      <div>
                        <p className="label">Division</p>
                        <p className="value">
                          {
                            Constants.getItemById(
                              frequentData?.divisions,
                              caseinfo?.divisionId,
                            )?.title
                          }
                        </p>
                      </div>
                      <div>
                        <p className="label">Classification</p>
      
                        <p className="value">
                          {
                            Constants.getItemById(
                              frequentData?.casecategories,
                              caseinfo?.caseCategoryId,
                            )?.categoryTitle
                          }
                        </p>
                      </div>
                      <div>
                        <p className="label">Date Initiated</p>
                        <p className="value">
                          {Constants.momentDate(caseinfo?.createdOn)?.format(
                            "DD MMM, YYYY",
                          )}
                        </p>
                      </div>
                      <div>
                        <p className="label">Case Type</p>
      
                        <p className="value">
                          {
                            Constants.getItemById(
                              frequentData?.casetype,
                              caseinfo?.caseTypeId,
                            )?.caseType1
                          }
                        </p>
                      </div>
                      <div>
                        <p className="label">Case Status</p>
      
                        <p className="value">
                          {
                            Constants.getItemById(
                              frequentData?.casestatuses,
                              caseinfo?.caseStatusId,
                            )?.description
                          }
                        </p>
                      </div>
                      <div>
                        <p className="label">Filing Type</p>
      
                        <p className="value">
                          {
                            Constants.getItemById(
                              frequentData?.filingtypes,
                              caseinfo?.caseFilingId,
                            )?.title
                          }
                        </p>
                      </div>
      
                    
                    </div>
                    
                 
                    
                  </section>
      <div className="input-group judge-note-input-wrapper">
        <label htmlFor="judge-recorder">Court Recorder’s Note</label>
        <div className="input-wrapper">
          <textarea
            placeholder="Text synchronizes dynamically here as you speak..."
            value={recorderText} readOnly={isListening}
            style={{ height: 300 }}
            onChange={(e) => setRecorderText(e.target.value)}
          />
        </div>
      </div>

      {/* Render the clean, modular voice tracking sub-component layout block */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "10px" }}>
        <JisVoiceRecorder 
        transcribeUrl={stribeurl} 
        token={token} 
        onTranscriptionComplete={handleNewTranscriptionText} 
        onStatusChange={onStatusChange}
      /> {!isListening && (
        <JisButton variant="outline" onClick={onSaveNote} style={{ marginLeft: "10px" }}>
          Save Record Note
        </JisButton>
      )}
      </div>
      
    </div>
  );
}

export default CourtRecorder;

